/**
 * Integer apportionment for fixed-size point grids (the Guardian Score
 * waffle, §7 C7): scale `parts` to sum to `target`, floor each share, then
 * hand the leftover points to the largest remainders (earlier parts win a
 * tie). The squares then add up to the score exactly, which plain rounding
 * can miss by one or two.
 *   largestRemainder([17.4, 21.2, 11.6, 23.8], 74) -> [17, 21, 12, 24]
 */
export function largestRemainder(parts: number[], target: number): number[] {
  const whole = Math.max(0, Math.round(target))
  const clean = parts.map((p) => (Number.isFinite(p) && p > 0 ? p : 0))
  const sum = clean.reduce((a, b) => a + b, 0)
  if (sum === 0 || whole === 0) return clean.map(() => 0)
  const exact = clean.map((p) => (p / sum) * whole)
  const out = exact.map(Math.floor)
  let left = whole - out.reduce((a, b) => a + b, 0)
  const order = exact.map((e, i) => ({ i, r: e - Math.floor(e) })).sort((a, b) => b.r - a.r || a.i - b.i)
  for (let k = 0; left > 0 && k < order.length; k++, left--) out[order[k].i]++
  return out
}
